const LoginIcon = () => {
  return (
   
      <svg
      

        // style={{ width: "24px", height: "24px" }}
        xmlns="http://www.w3.org/2000/svg"
     
        fill="#000000"
        viewBox="0 0 256 256"
      >
        <rect width="256" height="256" fill="none"></rect>
        <circle
          cx="128"
          cy="96"
          r="64"
          fill="none"
          stroke="#000000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="24"
        ></circle>
        <path
          d="M31,216a112,112,0,0,1,194,0"
          fill="none"
          stroke="#000000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="24"
        ></path>
      </svg>
    
  );
};
export default LoginIcon;
